import React from 'react';
import { ContentCard } from './ContentCard';

const ForbiddenCard = () => <ContentCard content="Vous n'êtes pas autorisé à accéder à cette page" />;

export default ForbiddenCard;
